'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/pdpRework/productDetail'));
    processInclude(require('./product/pdpRework/productTile'));
    processInclude(require('./product/pdpRework/detailElement'));
});
